// extracted by extract-css-chunks-webpack-plugin
module.exports = {"secondary-cta":"page-success__secondary-cta___EmCAp","secondaryCta":"page-success__secondary-cta___EmCAp"};
    if(module.hot) {
      // 1771895543513
      var cssReload = require("../../../../node_modules/extract-css-chunks-webpack-plugin/dist/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}","cssModules":true});
      module.hot.dispose(cssReload);
      ;
    }
  